var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnerSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5335",
    "data-name": "Group 5335",
    transform: "translate(-542 -102)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21444",
    "data-name": "Ellipse 21444",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(542 102)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M.987,9.754l-.056.016L0,1.821,4.082,5.293,6.023,0,8,5.39l4.195-3.569-.927,7.949-.1-.032c-.211.731-2.407,1.3-5.091,1.3C3.409,11.043,1.223,10.477.987,9.754Z",
    transform: "translate(546.125 105.998)",
    fill: "#d2d5da",
    opacity: 0.996
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerSlot);
export default __webpack_public_path__ + "static/media/owner-slot.7cdd7ead9e9962d416d3ee79027c7f0d.svg";
export { ForwardRef as ReactComponent };